<template>
  <div class="download-wrap">
    <el-dropdown
      trigger="click"
      placement="bottom-end"
      :disabled="disabled"
      @visible-change="handleToggle"
    >
      <span :class="['download-btn']" @click="handleRootBtn">
        {{$t('report.overview.operate.download.name')}}
        <el-icon class="el-icon--right" :class="{'active': visable}"><ArrowDown/></el-icon>
      </span>
      <template #dropdown v-if="visable">
        <el-dropdown-menu >
          <el-dropdown-item
            :disabled="gid<2"
            @click="handleDownload('pdf')"
           >
            <el-icon v-if="!isDownloadingPdf"><Download /></el-icon>
            <el-icon class="is-loading" v-else><Loading /></el-icon>
            {{$t('report.overview.operate.download.pdf')}}
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
    <UpgradeDialog
      v-model:show="isShowUpgrade"
      :type="upgradeType"
      :customText="customText"
      :showPoint="isLogin&&showPoint"
      :showNormal="!isLogin || showNormal"
    />
  </div>
</template>

<script>
import { t } from 'app/i18n'
import { mapActions, mapGetters, mapState } from 'vuex'

import { ArrowDown, Download, Loading } from '@element-plus/icons-vue'

import UpgradeDialog from '@/components/common/upgradeDialog'

import { download } from 'utils/tools'
import { message } from '@/hooks/useUI'
import { TaskStatus2Percent } from '@/utils/report.util'
import { batchDownloadReportPDF } from '@/services/report'

export default {
  name: 'DownloadPopover',
  components: {
    Loading,
    Download,
    ArrowDown,

    UpgradeDialog
  },
  props: {
    checkList: Array
  },
  computed: {
    ...mapGetters(['gid', 'isLogin']),
    ...mapState('user', ['userInfo']),
    disabled({ checkList }) {
      return !checkList?.length
    },
    /**
     * 是否包含未完成的任务；未完成的任务不可以下载PDF
     */
    containsUnfinishTask({ checkList }) {
      return checkList?.some(({ status }) => TaskStatus2Percent(status) < 100)
    },
    /**
     * 可用的下载PDF配额
     */
    quotaDownloadPDF({ userInfo }) {
      const pdfQuota = userInfo?.quota['download.pdf.frequency_1d']

      const total = pdfQuota?.quota || 0
      const used = pdfQuota?.quota_used || 0

      return parseInt(total - used)
    }
  },
  data() {
    return {
      visable: false,
      isDownloadingPdf: false,
      isShowUpgrade: false,
      upgradeType: '',
      customText: '',
      showNormal: false,
      showPoint: false
    }
  },
  methods: {
    ...mapActions({
      getQuota: 'user/getQuota'
    }),
    handleToggle(value) {
      this.visable = value
    },
    handleRootBtn() {
      if (this.disabled) {
        this.$store.commit('app/showMessage', { type: 'warning', message: t('taskhub.history.download_warn'), duration: 800 })
      }
    },
    async handleDownload(type) {
      if (type === 'pdf') {
        if (this.gid < 2) {
          this.showPoint = false
          this.isShowUpgrade = true
          this.customText = t('upgrade.normal')
          return
        }
        const { containsUnfinishTask, quotaDownloadPDF, checkList } = this
        if (containsUnfinishTask) { // 包含未完成或失败的任务
          message(t('report.overview.operate.download.batch.pdf.unreported'), 'error')
          return
        }

        const diff = parseInt(quotaDownloadPDF - checkList.length)

        if (diff < 0) {
          message(t('report.overview.operate.download.batch.pdf.quota', [quotaDownloadPDF]), 'error')
          return
        }
        this.downloadPDF()
      }
    },
    async downloadPDF() {
      const { isDownloadingPdf, checkList } = this
      if (isDownloadingPdf) {
        message(t('report.overview.operate.download.process'), 'error')
        return
      }
      this.isDownloadingPdf = true
      const timeout = setTimeout(() => {
        message(t('report.overview.operate.download.ing'))
      }, 2000)
      const task_ids = checkList.map(({ id }) => id)

      batchDownloadReportPDF({ task_ids }).then(res => {
        timeout && clearTimeout(timeout)
        message(t('report.overview.operate.download.process'))
        this.isDownloadingPdf = false

        // 获取header中的文件名称
        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        const matches = filenameRegex.exec(res.headers['content-disposition'])
        const filename = matches ? matches[1].replace(/['"]/g, '') : 'report.zip'

        download({
          content: res.data,
          type: 'application/zip',
          filename: `${filename}`
        })
        this.getQuota()
      }).catch(() => {
        timeout && clearTimeout(timeout)
        this.isDownloadingPdf = false
      })
    }
  }
}
</script>

<style lang='scss' scoped>
@import '@/styles/common.scss';
.download-wrap {
  display: inline;
}
.download-btn {
  height: 32px;
  // width: 130px;
  line-height: 32px;
  display: inline-block;
  vertical-align: bottom;
  border-radius: 4px;
  font-size: 14px;
  color: var(--color-text-2);
  padding-left: 10px;
  cursor: pointer;
  position: relative;
  .el-icon {
    position: relative;
    top:2px;
    transition: all .2s
  }
  .active {
    transform: rotateZ(180deg);
  }
  .arrow {
    position: absolute;
    right: 6px;
    top: 8px;
  }
  &:focus {
    outline: 0;
  }
  &.disabled {
    border-color: #333E6B;
    pointer-events: none;
  }
}
</style>
